
import { useEffect } from 'react';
import PastEventItems from '../components/PastEventItems';
import { useAuditLogger } from '../hooks/UseAuditLogger.js';

export default function PastEvents() {
  const { logEvent } = useAuditLogger();
  useEffect(() => {
    logEvent({
      eventType: 'page.view',
      action: 'READ',
      requestData: { pageName: 'Past events' },
    });
  }, [logEvent]);

  return (
    <div className="main">
      <PastEventItems />
    </div>
  );
}
